/*
 * Copyright (c) 2008-present Sonatype, Inc.
 *
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/pro/attributions
 * Sonatype and Sonatype Nexus are trademarks of Sonatype, Inc. Apache Maven is a trademark of the Apache Foundation.
 * M2Eclipse is a trademark of the Eclipse Foundation. All other trademarks are the property of their respective owners.
 */
import React from 'react';
import { LoginPage } from '@sonatype/nexus-ui-plugin';

/**
 * Cloud UI login page wrapper.
 * Logo and edition badge are handled by LoginLayout (neutral wordmark plus edition badge).
 */
export default function CloudUILoginPageWrapper() {
  return <LoginPage />;
}
